const MufiListCount = (state = null, action) => {
    switch (action.type) {
        case 'MuftiCount_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default MufiListCount